// ElevenLabs Eleven v4 voices available through Fal.
// https://fal.ai/models/elevenlabs/tts/eleven-v4/api
export const READ_ALOUD_VOICES = [
  { value: 'female', providerVoice: 'Rachel' },
  { value: 'male', providerVoice: 'Roger' },
];

export const DEFAULT_READ_ALOUD_VOICE = 'female';

export const normalizeReadAloudVoice = (value) => (
  READ_ALOUD_VOICES.some(voice => voice.value === value) ? value : DEFAULT_READ_ALOUD_VOICE
);

export const getReadAloudProviderVoice = (value) => (
  READ_ALOUD_VOICES.find(voice => voice.value === normalizeReadAloudVoice(value)).providerVoice
);
